export interface PhonePrefixDto {
  prefix: string;
  countryTwoLetter: string;
}

export class PhonePrefixLookup {
  public static readonly phonePrefixes: PhonePrefixDto[] = [
    { prefix: '+48', countryTwoLetter: 'PL' },
  ];
}
